<div class="d-f jc-sb ai-c mb-xxs">
	<div>&nbsp;</div>
	<button mat-flat-button color="primary" routerLink="cadastro">
		<mat-icon>add</mat-icon>
		<span class="no-mob">Novo cargo</span>
	</button>
</div>
<div class="d-f jc-c ai-c w-100 loader" *ngIf="loading$ | async">
	<mat-spinner diameter="20"></mat-spinner>
</div>
<div
	class="d-f jc-fs"
	*ngIf="(loading$ | async) === false && !positions.length"
>
	<p class="fs-xs lh-xs fs-i gray">Nenhum cargo cadastrado</p>
</div>
<div class="d-f f-w cards" *ngIf="(loading$ | async) === false">
	<div
		class="pos-r mb-xxs pb-nano br-md card"
		*ngFor="let position of positions; let index = index"
	>
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md">
			<div class="d-f ai-c jc-sb mb-xxs">
				<span class="mt-quark fs-xs fw-bold lh-xs to-ellipsis">
					{{ position.name }}
				</span>
				<div
					class="d-f jc-c ai-c mr-xxxs c-p squared"
					[matMenuTriggerFor]="menu"
				>
					<mat-icon svgIcon="sanus-more-blue"></mat-icon>
				</div>
			</div>
			<div class="d-f ai-c mb-xxs">
				<mat-icon svgIcon="sanus-wage-blue"></mat-icon>
				<div class="d-f fd-c jc-c ml-nano col-2">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Salário mínimo</span>
					<span
						class="mt-quark fs-xs lh-xs {{ position.min_wage ? '' : 'gray' }}"
					>
						{{
							position.min_wage
								? 'R$ ' + (position.min_wage | number: '1.2' : 'es')
								: 'Não definido'
						}}
					</span>
				</div>
				<mat-icon svgIcon="sanus-wage-blue"></mat-icon>
				<div class="d-f fd-c jc-c ml-nano col-2">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Salário máximo</span>
					<span
						class="mt-quark fs-xs lh-xs {{ position.max_wage ? '' : 'gray' }}"
					>
						{{
							position.max_wage
								? 'R$ ' + (position.max_wage | number: '1.2' : 'es')
								: 'Não definido'
						}}
					</span>
				</div>
			</div>
			<div class="d-f ai-c mb-xxs">
				<mat-icon svgIcon="sanus-location-blue"></mat-icon>
				<div class="d-f fd-c jc-c ml-nano">
					<span class="fs-xxxs fw-bold lh-xxxs gray">Cidade/estado</span>
					<span class="mt-quark fs-xs lh-xs {{ position.state ? '' : 'gray' }}">
						{{ position.city ? position.city + '/' : ''
						}}{{ position.state ? position.state : 'Não definido' }}
					</span>
				</div>
			</div>
			<div class="d-f fd-c jc-c">
				<span class="fs-xxxs fw-bold lh-xxxs gray">Planos</span>
				<ng-container
					*ngFor="let benefit of position.benefits; let bIdx = index"
				>
					<span class="mt-quark fs-xs lh-xs to-ellipsis" *ngIf="bIdx < 3">
						{{ benefit }}
					</span>
				</ng-container>
				<span
					class="mt-quark fs-xs lh-xs fs-i to-ellipsis"
					class="color-text-gray"
					*ngIf="!position.benefits.length"
				>
					Não há plano para este cargo
				</span>
				<span
					class="mt-quark fs-xs lh-xs c-p"
					class="color-text-gray"
					*ngIf="position.benefits.length > 3"
					(click)="onEditPosition(position.id)"
				>
					Mais
				</span>
			</div>
		</div>
		<mat-menu #menu="matMenu">
			<button mat-menu-item (click)="onEditPosition(position.id)">
				Editar cargo
			</button>
			<button mat-menu-item (click)="onClonePosition(position.id)">
				Criar novo a partir deste
			</button>
			<button mat-menu-item (click)="onDeletePosition(position.id)">
				Excluir
			</button>
		</mat-menu>
	</div>
</div>
<div class="mb-huge"></div>
